import React, { useEffect, useMemo } from 'react';

import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { STATE } from 'app/constants';
import { useTranslation } from 'app/infrastructure/translate/hooks';
import { OverlayComponent } from 'app/components';
import { hasChanges } from '../utils/has-changes';
import { activeItemSelected } from '../utils/selected-value';
import { linkCodesTranslation } from '../constants';
import { useDetailsSelectors, useListActionsSelectors, useListBranchSelectors } from '../hooks';
import { LinkCodesDetails } from './link-codes-details';
import { LinkCodesErrors } from './link-codes-errors';
import { LinkCodesHeader } from './link-codes-header';
import { LinkCodesPrompt } from './link-codes-prompt';
import { LinkCodesResults } from './link-codes-results';
import { scrollToTop } from 'app/infrastructure/platform/routing';
import { RouterProps } from 'app/components/enhancers/with-router';
import styles from './link-codes-list.scss';

interface LinkCodesListProps {
  breadcrumbs: number[];
  router: RouterProps;
  linkSubset: boolean;
}

export const LinkCodesList: React.FC<LinkCodesListProps> = ({
  breadcrumbs, router, linkSubset
}) => {

  const { listBranch } = useListBranchSelectors();
  const { listActions, updating, activeValueError } = useListActionsSelectors();
  const { activeValue, activeType } = useDetailsSelectors();

  const shouldPrompt = useMemo(
    () => hasChanges(listBranch, listActions, activeItemSelected(activeValue, activeType)),
    [listBranch, listActions, activeValue?.value, activeType]
  );

  const translation = useTranslation(STATE.linkCodes, linkCodesTranslation);

  useEffect(() => scrollToTop(), []);

  return <>
    <LinkCodesPrompt
      router={router}
      shouldPrompt={shouldPrompt}
      translation={translation} />
    <LinkCodesErrors
      translation={translation} />
    <OverlayComponent
      displayOverlay={updating}
      overlayText={translation.message_updating} />
    <div className={styles.header}>
      <MainGridContainer>
        <LinkCodesHeader
          linkSubset={linkSubset}
          breadcrumbs={breadcrumbs}
          translation={translation} />
        <LinkCodesDetails
          shouldPrompt={shouldPrompt}
          activeValueError={activeValueError}
          translation={translation} />
      </MainGridContainer>
    </div>
    <div className={styles.body}>
      <MainGridContainer>
        <LinkCodesResults
          codetableId={breadcrumbs?.[1]}
          hasChanges={shouldPrompt}
          translation={translation} />
      </MainGridContainer>
    </div>
  </>;
};
